export default __webpack_public_path__ + "media/images/theme/bg_light-4ff1f6764e2ebdbf78ea608da9bd1850.png";